import React, { useEffect } from 'react';
import { isHelpCenterAIAnswersEAPEnabled, isUnifiedHelpForcedFeedbackFlowEnabled } from '@helpCenter/feature-flags';
import { graphql, useFragment } from 'react-relay';
import SlideIn from '@atlaskit/motion/slide-in';
import { useConversation, useIsFeedbackRecorded } from '../../store/converse';
import type { ConversationUser$key } from './__generated__/ConversationUser.graphql';
import { ConversationMessageList } from './conversation-message-list';
import { ConversationFlipper, ConversationWrapper } from './Conversation.styled';
import { ConversationInput } from './ConversationInput';

export const Conversation: React.VFC<{
    userRef: ConversationUser$key;
}> = ({ userRef }) => {
    const [conversation, { setProviderAuthStatus }] = useConversation();
    const [isFeedbackRecorded] = useIsFeedbackRecorded();

    const userData = useFragment(
        graphql`
            fragment ConversationUser on User {
                ...conversationMessageListUser
                ...ConversationInputUser
            }
        `,
        userRef
    );

    const isConverseInputVisible =
        isUnifiedHelpForcedFeedbackFlowEnabled() && !isHelpCenterAIAnswersEAPEnabled() ? isFeedbackRecorded : true;

    useEffect(() => {
        // setting 3P auth status if user directly lands on conversation page
        if (!conversation) {
            // eslint-disable-next-line @typescript-eslint/no-floating-promises
            setProviderAuthStatus();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <ConversationWrapper>
            <>
                <SlideIn enterFrom="bottom">
                    {(props) => (
                        <ConversationFlipper flipKey={conversation?.history.length ?? 0} {...props}>
                            <ConversationMessageList userRef={userData} />
                            {isConverseInputVisible && <ConversationInput userRef={userData} />}
                        </ConversationFlipper>
                    )}
                </SlideIn>
            </>
        </ConversationWrapper>
    );
};
